import { render } from "./SendWindowEditor.vue?vue&type=template&id=4e0ca56f"
import script from "./SendWindowEditor.vue?vue&type=script&lang=js"
export * from "./SendWindowEditor.vue?vue&type=script&lang=js"

import "./SendWindowEditor.vue?vue&type=style&index=0&id=4e0ca56f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__